import { render, staticRenderFns } from "./AddressStatus.vue?vue&type=template&id=2c8b4da0"
import script from "./AddressStatus.vue?vue&type=script&lang=ts"
export * from "./AddressStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports